import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import type { Article, CategoryInfo, ContentType } from '@/types/content';

export const SORT_OPTIONS = [
  { key: 'latest', label: '最新发布' },
  { key: 'hot', label: '最热资讯' },
] as const;

export type SortKey = (typeof SORT_OPTIONS)[number]['key'];

export function getAllArticles(): Article[] {
  return articles as Article[];
}

export function getArticleById(id: string): Article | undefined {
  return (articles as Article[]).find((item) => item.id === id);
}

export function getCategory(key: string): CategoryInfo | undefined {
  return (categories as CategoryInfo[]).find((item) => item.key === key);
}

export function getAllCategories(): CategoryInfo[] {
  return categories as CategoryInfo[];
}

export function getArticlesByCategory(type: string, subcategory?: string): Article[] {
  return (articles as Article[]).filter((item) => {
    if (item.category !== type && item.type !== type) return false;
    if (subcategory && subcategory !== '全部' && item.subcategory !== subcategory) return false;
    return true;
  });
}

export function sortArticles(list: Article[], sort: SortKey): Article[] {
  const copied = [...list];
  if (sort === 'hot') {
    return copied.sort((a, b) => b.views - a.views);
  }
  return copied.sort((a, b) => (a.date < b.date ? 1 : -1));
}

export function searchArticles(keyword: string): Article[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return (articles as Article[]).filter((item) => {
    const haystack = [
      item.title,
      item.summary,
      item.synopsis,
      item.subcategory,
      ...item.tags,
      ...item.cast,
      item.director,
    ]
      .join(' ')
      .toLowerCase();
    return haystack.includes(q);
  });
}

export function getRelatedArticles(article: Article, limit = 3): Article[] {
  return (articles as Article[])
    .filter((item) => item.id !== article.id && (item.category === article.category || item.type === article.type))
    .slice(0, limit);
}

export function formatDate(date: string): string {
  const [y, m, d] = date.split('-');
  return `${y} 年 ${Number(m)} 月 ${Number(d)} 日`;
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)} 万`;
  }
  return `${views}`;
}

export const TYPE_LABEL: Record<ContentType, string> = {
  plot: '剧情介绍',
  news: '资讯报道',
  feature: '花絮专题',
};

export const FAVORITES_KEY = 'fzsa2_favorites';

export function readFavorites(): string[] {
  try {
    const raw = localStorage.getItem(FAVORITES_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function writeFavorites(ids: string[]): void {
  try {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(ids));
  } catch {
    // ignore storage errors
  }
}